/** @format */

export const TARGET_BUTTONS_GAP_PX = 5;

export const BUTTON_WIDTH = 32;
